// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pSdUj1RX2kLKo5IFALO4 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 64px;
  z-index: 500;
  width: 100%;
  position: fixed;
  padding: 0;
}
.pSdUj1RX2kLKo5IFALO4 .i3H1myDP7fikVWe0ilUL {
  background-color: unset;
  color: var(--navbar-text-color);
  box-shadow: unset;
  height: 80px;
  padding-bottom: 0;
  right: unset;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.RaEtOWr8YUc0fKmb0TbH {
  height: 40px;
  margin-left: -40px;
}

.mTP3q99p4VbgRRTCN_34 {
  border-bottom: 2px solid var(--grey-gradient-end-color-10);
  position: fixed;
  width: 999%;
  height: 96px;
  background-color: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(5px);
}

.qjz1O7cqmx3gWI4SrFYG {
  margin-left: 56px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.nZRlMzIIL1E1ZXGwHCJj {
  width: 1px;
  height: 24px;
  background-color: var(--grey-color-300);
  margin-left: 16px;
  position: relative;
  top: -4px;
}

.AQj0qjGusBKgpXIQViBm {
  width: 143px;
  height: 60px;
  margin-right: 24px;
}

.JUFDT6sEavzx6xBqyIaS {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.y5Sa04ATpEVxqL0S38Qv {
  width: 138px;
  height: 38px;
  margin-right: 24px;
}

.qJN97hnxnancylsvLDbI {
  text-transform: uppercase;
  font-size: 20px;
  font-weight: 800;
  line-height: 23px;
  color: var(--grey-color-90);
  font-family: var(--font-stack-full-medium);
  text-wrap: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;AACF;AACE;EACE,uBAAA;EACA,+BAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AACJ;;AAGA;EACE,YAAA;EACA,kBAAA;AAAF;;AAGA;EACE,0DAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,0CAAA;EACA,0BAAA;AAAF;;AAGA;EACE,iBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAAF;;AAGA;EACE,UAAA;EACA,YAAA;EACA,uCAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;AAAF;;AAGA;EACE,YAAA;EACA,YAAA;EACA,kBAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAAF;;AAGA;EACE,YAAA;EACA,YAAA;EACA,kBAAA;AAAF;;AAGA;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,2BAAA;EACA,0CAAA;EACA,iBAAA;AAAF","sourcesContent":[".headerContainer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 64px;\n  z-index: 500;\n  width: 100%;\n  position: fixed;\n  padding: 0;\n\n  .tabBar {\n    background-color: unset;\n    color: var(--navbar-text-color);\n    box-shadow: unset;\n    height: 80px;\n    padding-bottom: 0;\n    right: unset;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n  }\n}\n\n.customLogo {\n  height: 40px;\n  margin-left: -40px;\n}\n\n.headerBackground {\n  border-bottom: 2px solid var(--grey-gradient-end-color-10);\n  position: fixed;\n  width: 999%;\n  height: 96px;\n  background-color: rgba(255, 255, 255, 0.9);\n  backdrop-filter: blur(5px);\n}\n\n.logoContainer {\n  margin-left: 56px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.verticalRule {\n  width: 1px;\n  height: 24px;\n  background-color: var(--grey-color-300);\n  margin-left: 16px;\n  position: relative;\n  top: -4px;\n}\n\n.logo {\n  width: 143px;\n  height: 60px;\n  margin-right: 24px;\n}\n\n.link {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.cohortAndSuccessProfileLogo {\n  width: 138px;\n  height: 38px;\n  margin-right: 24px;\n}\n\n.adminPortalIntegration {\n  text-transform: uppercase;\n  font-size: 20px;\n  font-weight: 800;\n  line-height: 23px;\n  color: var(--grey-color-90);\n  font-family: var(--font-stack-full-medium);\n  text-wrap: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerContainer": `pSdUj1RX2kLKo5IFALO4`,
	"tabBar": `i3H1myDP7fikVWe0ilUL`,
	"customLogo": `RaEtOWr8YUc0fKmb0TbH`,
	"headerBackground": `mTP3q99p4VbgRRTCN_34`,
	"logoContainer": `qjz1O7cqmx3gWI4SrFYG`,
	"verticalRule": `nZRlMzIIL1E1ZXGwHCJj`,
	"logo": `AQj0qjGusBKgpXIQViBm`,
	"link": `JUFDT6sEavzx6xBqyIaS`,
	"cohortAndSuccessProfileLogo": `y5Sa04ATpEVxqL0S38Qv`,
	"adminPortalIntegration": `qJN97hnxnancylsvLDbI`
};
export default ___CSS_LOADER_EXPORT___;
